import { Component, Input, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { DownloadNotificationService } from '../../root-services/download-notification.service';

import { EditionService } from '../services/edition.service';
import { PermissionsService } from '../services/permissions.service';
import { AnalyticsService } from '../../analytics/analytics.service';
import { CurrentUserService }         from '../../shared/services/current-user.service';

// RxJS Interfaces
import { AnalyticsStateObject } from '../../models/analytics/analytics-state-object';
import { PlainDropdownComponent } from '../plain-dropdown/plain-dropdown.component';
import { AllPermissions } from '../../models/permissions';
import { EditionSettings } from '../../models/global/edition-settings';
import { ISubscription } from 'rxjs/Subscription';
import { CurrentUser } from '../../models/current-user';

@Component({
  selector: 'app-download-selector',
  templateUrl: './download-selector.component.html',
  styleUrls: ['./download-selector.component.less']
})
export class DownloadSelectorComponent implements OnInit, OnDestroy {

    public permissions: AllPermissions;
    private editionSub: ISubscription;
    private editionHasAttachedSession = false;
    private editionHasAttachedSubscription = false;
    private editionHasSSO = false;
    private editionId: Number;
    public downloadsEnabledForUser = false;
    @Input() stateObj: AnalyticsStateObject;

    @ViewChild('downloadDropdown') downloadDropdown: PlainDropdownComponent;

    constructor(
      private downloadNotificationService: DownloadNotificationService,
      private analyticsService: AnalyticsService,
      private permissionsService: PermissionsService,
      private editionService: EditionService,
      private currentUserService: CurrentUserService
    ) {}

    ngOnInit() {
      this.permissionsService.retrievePermissions().subscribe(permissions => {
        this.permissions = permissions;
      });
      this.subscribeToGetEditionDetails();
      this.currentUserService.getUserData().subscribe(user => {
        this.downloadsEnabledForUser = !user.disable_exports;
      });
    }

    ngOnDestroy() {
      this.editionSub.unsubscribe();
    }

    public startDownload(downloadRef) {
      this.analyticsService.generateGenericReport(downloadRef, this.stateObj).subscribe(resp => {
        if (resp.state === 'started') {
          this.downloadNotificationService.registerNewDownload(resp);
        }
      });
      this.downloadDropdown.close();
    }

    private subscribeToGetEditionDetails(): void {
      this.editionSub = this.editionService
          .getEdition()
          .subscribe((edition: EditionSettings) => {
            this.editionHasAttachedSession = edition.has_attached_session;
            this.editionHasAttachedSubscription = edition.has_attached_subscription;
            this.editionHasSSO = !!edition.sso_field_name;
            this.editionId = edition.id;
          });
    }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/download-selector/download-selector.component.ts